module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/lpo_features_04-d1b2dd5ce9124d8c836a3b0b3251a558.png";